module.exports = __webpack_public_path__ + "static/stopklatka-39-b111d9d2c73115da44b8cb4983174302.jpg";